export default __webpack_public_path__ + "static/media/profile.6829dc4b.svg";